import {CheckCircleOutlined, InfoCircleOutlined} from "@ant-design/icons";
import {ReactNode} from "react";
import {
  StyledIntegrationConnectButton,
  StyledIntegrationConnectPanel,
  StyledIntegrationStatusBanner,
} from "../../automations.style";

type IntegrationConnectPanelProps = {
  title: string;
  bulletPoints: string[];
  connectLabel: string;
  disconnectLabel: string;
  isConnected: boolean;
  onConnect: () => void;
  onDisconnect: () => void;
  isConnectLoading?: boolean;
  isDisconnectLoading?: boolean;
  connectedStatusMessage?: ReactNode;
  disconnectedStatusMessage?: ReactNode;
};

export function IntegrationConnectPanel({
  title,
  bulletPoints,
  connectLabel,
  disconnectLabel,
  isConnected,
  onConnect,
  onDisconnect,
  isConnectLoading = false,
  isDisconnectLoading = false,
  connectedStatusMessage,
  disconnectedStatusMessage,
}: IntegrationConnectPanelProps) {
  const statusMessage = isConnected ? connectedStatusMessage : disconnectedStatusMessage;
  const showStatusBanner = Boolean(statusMessage);

  return (
    <StyledIntegrationConnectPanel>
      <h2>{title}</h2>
      <ul>
        {bulletPoints.map((point) => (
          <li key={point}>{point}</li>
        ))}
      </ul>
      {showStatusBanner && (
        <StyledIntegrationStatusBanner $variant={isConnected ? "success" : "info"}>
          {isConnected ? (
            <CheckCircleOutlined className="integration-status-banner-icon" />
          ) : (
            <InfoCircleOutlined className="integration-status-banner-icon" />
          )}
          <span>{statusMessage}</span>
        </StyledIntegrationStatusBanner>
      )}
      {isConnected ? (
        <StyledIntegrationConnectButton
          type="default"
          onClick={onDisconnect}
          loading={isDisconnectLoading}
          disabled={isDisconnectLoading}
        >
          {disconnectLabel}
        </StyledIntegrationConnectButton>
      ) : (
        <StyledIntegrationConnectButton
          type="primary"
          onClick={onConnect}
          loading={isConnectLoading}
          disabled={isConnectLoading}
        >
          {connectLabel}
        </StyledIntegrationConnectButton>
      )}
    </StyledIntegrationConnectPanel>
  );
}
